import request from '@/utils/request';

/**
 * 商户分类
 */
export function dkMerchantCategoryAddApi(data) {
  return request({
    url: 'admin/dkMerchantCategory/add',
    method: 'POST',
    data: data
  });
}
export function dkMerchantCategorygetallApi(data) {
  return request({
    url: 'admin/dkMerchantCategory/getall',
    method: 'GET',
    params: data
  });
}
export function dkMerchantCategorydeleteApi(id) {
  return request({
    url: "admin/dkMerchantCategory/delete/".concat(id),
    method: 'GET'
  });
}
export function dkMerchantCategoryupdateApi(id, data) {
  return request({
    url: "admin/dkMerchantCategory/update/".concat(id),
    method: 'POST',
    data: data
  });
}

/**
 * 店铺类型
 */
export function dkMerchantTypeAddApi(data) {
  return request({
    url: 'admin/dkMerchantType/add',
    method: 'POST',
    data: data
  });
}
export function dkMerchantTypegetallApi(data) {
  return request({
    url: 'admin/dkMerchantType/getall',
    method: 'GET',
    params: data
  });
}
export function dkMerchantTypedeleteApi(id) {
  return request({
    url: "admin/dkMerchantType/delete/".concat(id),
    method: 'GET'
  });
}
export function dkMerchantTypeupdateApi(id, data) {
  return request({
    url: "admin/dkMerchantType/update/".concat(id),
    method: 'POST',
    data: data
  });
}

/**
 * 商户入驻
 */
export function dkMerchantIntentionAddApi(data) {
  return request({
    url: "admin/dkMerchantIntention/apply",
    method: 'POST',
    data: data
  });
}
/**
 * 商户编辑-审核
 */
export function dkMerchantIntentioneditApplyApi(id, data) {
  return request({
    url: "admin/dkMerchantIntention/editApply/".concat(id),
    method: 'POST',
    data: data
  });
}
/**
 * 商户删除
 */
export function dkMerchantIntentiondeletebyidApi(data) {
  return request({
    url: "admin/dkMerchantIntention/deletebyid",
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data.toString()
  });
}
/**
 * 获取当前登录用申请的店铺信息
 */
export function dkMerchantIntentionlistByUserIdApi() {
  return request({
    url: "admin/dkMerchantIntention/listByUserId",
    method: 'GET'
  });
}

/**
 * 查询商户信息
 */
export function dkMerchantsearmersApi(data) {
  return request({
    url: "admin/dkMerchant/searmers",
    method: 'POST',
    data: data
  });
}

/**
 * 设置商户开启/关闭
 */
export function dkMerchantstatesetApi(data) {
  return request({
    url: "admin/dkMerchant/stateset",
    method: 'POST',
    data: data
  });
}

/**
 * 设置商户商品是否需要审核
 */
export function dkMerchantisauditsetApi(data) {
  return request({
    url: "admin/dkMerchant/isauditset",
    method: 'POST',
    data: data
  });
}

/**
 * 导出
 */
export function dkMerchantexportExcelApi(data) {
  return request({
    url: "admin/dkMerchant/exportExcel",
    method: 'POST',
    responseType: 'blob',
    // headers: {
    //   'Content-Type': 'application/json'
    // },
    data: data
  });
}

/**
 * 审核商品
 */
export function dkMerchantauditApi(data) {
  return request({
    url: "admin/store/product/produtstateupdate",
    method: 'POST',
    data: data
  });
}
/**
 * 批量下架
 */
export function dkMerchantbatchTakeOffShelfApi(data) {
  return request({
    url: "admin/store/product/batchoff",
    method: 'POST',
    data: data
  });
}
/**
 * 批量上架
 */
export function dkMerchantbatchPutOnShelfApi(data) {
  return request({
    url: "admin/store/product/batchputon",
    method: 'POST',
    data: data
  });
}
/**
 * 批量更改状态
 */
export function dkMerchantbatchupdatestateApi(data) {
  return request({
    url: "admin/store/product/batchupdatestate",
    method: 'POST',
    data: data
  });
}

/**
 * 获取当前登录用户申请的商户信息
 */
export function dkMerchantloginusersmerApi() {
  return request({
    url: "admin/dkMerchant/loginusersmer",
    method: 'GET'
  });
}

/**
 * 批量定时上架
 */
export function dkMerchantbatchScheduleShelfApi(data) {
  return request({
    url: "admin/store/product/scheduleputon",
    method: 'POST',
    data: data
  });
}

/**
 * 交易明细
 */
export function dkOrderTranslistApi(data) {
  return request({
    url: "admin/store/order/translist",
    method: 'POST',
    data: data
  });
}

/**
 * 销售情况统计分页列表
 */
export function dkMerchantSalesStatisticslistApi(data) {
  return request({
    url: "admin/store/order/stat/list",
    method: 'GET',
    params: data
  });
}

/**
 * 销售统计
 */
export function salesStatisticsApi(params) {
  return request({
    url: "admin/store/order/stat/list/sum",
    method: 'get',
    params: params
  });
}

/**
 * 批量增加余额
 */
export function usersFoundsApi(data) {
  return request({
    url: "admin/user/operate/users/founds",
    method: 'GET',
    params: data
  });
}

/**
 * 卖家收货
 */
export function dkMerchantSellerReceiveApi(data) {
  return request({
    url: "admin/store/order/takeGood",
    method: 'GET',
    params: data
  });
}

/**
 * 修改保证金金额
 */
export function dkeditdepositApi(data) {
  return request({
    url: "admin/dkMerchant/editdeposit",
    method: 'POST',
    data: data
  });
}

/**
 * 购物车数量
 */
export function dkcartlistNumApi(data) {
  return request({
    url: "admin/store/order/cartlist",
    method: 'GET',
    params: data
  });
}

/**
 * 同步ChangeCloud供应链上架产品
 */
export function dkMerchantsyncChangeCloudApi() {
  return request({
    url: "admin/store/product/importchangecloudproduct",
    method: 'POST'
  });
}

/**
 * 订单明细导出
 */
export function orderDetailExportApi(data) {
  return request({
    url: "/admin/store/order/translistexcel",
    method: 'POST',
    responseType: 'blob',
    data: data
  });
}